import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-surface-light dark:bg-surface-dark pt-4 pb-4 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center pb-3 gap-2">
          <div>
            <img src="/sf_logo.webp" alt="Studio Fernandes" style={{width: '100px', height: '130px'}} className="object-contain" />
          </div>
          <nav className="flex flex-row gap-8 text-sm text-gray-500 dark:text-gray-400">
            <Link className="hover:text-primary transition-colors" to="/">Home</Link>
            <Link className="hover:text-primary transition-colors" to="/our-story">Our Story</Link>
            <Link className="hover:text-primary transition-colors" to="/corporate">Corporate</Link>
            <Link className="hover:text-primary transition-colors" to="/visit-store">Visit Store</Link>
          </nav>
        </div>

        {/* Locations — full width horizontal */}
        <div className="border-t border-gray-200 dark:border-gray-700 pt-6 pb-6">
          <h4 className="font-bold text-sm uppercase tracking-wide mb-6 text-gray-900 dark:text-gray-200">Locations</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <p className="text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Bhayandar East</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Shop No 20 &amp; 21, Sarvodaya Complex, Golden Nest Circle, Thane 401105</p>
              <a className="text-xs underline hover:text-primary" href="https://maps.google.com/?q=Sarvodaya+Complex+Golden+Nest+Circle+Bhayandar+East+Thane" target="_blank" rel="noopener noreferrer">Google Map</a>
            </div>
            <div>
              <p className="text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Borivali West</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Shop No. 1, Harmony Society Ltd, IC Colony, Mumbai 400103</p>
              <a className="text-xs underline hover:text-primary" href="https://maps.google.com/?q=Harmony+Society+Holy+Cross+Road+IC+Colony+Borivali+West+Mumbai" target="_blank" rel="noopener noreferrer">Google Map</a>
            </div>
            <div>
              <p className="text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">Charni Road</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Hirabaug, Cawasji Patel Tank Rd, Charni Road, Mumbai 400004</p>
              <a className="text-xs underline hover:text-primary" href="https://maps.google.com/?q=Hirabaug+Cawasji+Patel+Tank+Road+Charni+Road+Mumbai" target="_blank" rel="noopener noreferrer">Google Map</a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-300 dark:border-gray-800 pt-4 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
          <p>© 2026 Studio Fernandes — Copyright</p>
          <p className="mt-2 md:mt-0 text-xs text-gray-400">Made with <span className="text-primary">♥</span> by <a href="https://tecnomi.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Tecnomi</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
